import React, { useState } from "react";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import { Form, Row, Col } from "react-bootstrap";
import { useForm } from "react-hook-form";
import axios from "axios";
import { showSuccessToast, showErrorToast } from "../../Utils/toastUtils";


const CreateSeller = (props) => {
  const { register, handleSubmit } = useForm();
  const submit = props.submit
  const getData = props.getData
  const modal = props.modal
  const setModal = props.setModal

  const [name, setName] = useState("")
  const [domain, setDomain] = useState("")
  // const [sellerType, setSellerType] = useState("")
  const [sellerID, setSellerID] = useState("")
  const [selectedSellerType, setSelectedSellerType] = useState("");

  const sellerTypeOptions = [
    { value: "PUBLISHER", label: "PUBLISHER" },
    { value: "INTERMEDIARY", label: "INTERMEDIARY" },
    { value: "BOTH", label: "BOTH" },
  ];

  const setSellerType = (selectedValue) => {
    setSelectedSellerType(selectedValue);
  };
  const cleardata = () => {
    setSellerID("")
    setName("")
    setDomain("")
    setSelectedSellerType("")


  }
  const handleFormData = () => {
    if (sellerID.length === 0) {
      showErrorToast("Input SellerID");
      return
    }
    if (name.length === 0) {
      showErrorToast("Input name");
      return
    }
    if (domain.length === 0) {
      showErrorToast("Input User Domain");
      return
    }
    if (selectedSellerType.length === 0) {
      showErrorToast("Input Seller Type");
      return
    }
  }
  const submitData = (e) => {
    e.preventDefault();
    handleFormData()
    let postData = {
      seller_id: sellerID,
      name: name,
      domain: domain,
      seller_type: selectedSellerType
    }
    let data = axios.post(`/api/sellers`, postData, {
      headers: {
        Authorization: 'Bearer ' + sessionStorage.getItem('userToken')
      }
    })
      .then(response => {
        console.log(response.data)
        cleardata()
        showSuccessToast((response.data && response.data.Message) ? response.data.Message : "Success")
      })
      .catch(error => {
        console.error('Error making POST request:', error);
        cleardata()
        showErrorToast("Error")

      });
    getData()
    setModal(!modal)

  }



  return (
    <div>
      <Modal size="lg" backdropClassName="" isOpen={modal} toggle={() => setModal(!modal)}>
        <ModalHeader toggle={() => setModal(!modal)}>
          Create Seller
        </ModalHeader>
        <ModalBody >
          <form >
            <div className="input-group input-group-outline my-3">
              <input
                type="text"
                className="form-control"
                placeholder="Seller ID"
                onChange={(e) => setSellerID(e.target.value)}
              />
            </div>
            <div className="input-group input-group-outline my-3">
              <input
                type="text"
                className="form-control"
                placeholder="Seller Name"
                onChange={(e) => setName(e.target.value)}
              />
            </div>
            <div className="input-group input-group-outline mb-3">
              <input
                type="text"
                className="form-control"
                placeholder="Domain"
                onChange={(e) => setDomain(e.target.value)}
              />
            </div>
            <div className="input-group input-group-outline mb-3">
              <Form.Control
                as="select"
                className="form-control"
                value={selectedSellerType}
                onChange={(e) => setSellerType(e.target.value)}
              >
                <option value="">Select Seller Type</option>
                {sellerTypeOptions.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </Form.Control>
            </div>

            <div className="text-center">
              <button
                type="submit"
                className="btn bg-gradient-info  w-15 my-5 mb-2"
                onClick={(e) => submitData(e)}
              >
                Save
              </button>
            </div>
          </form>
        </ModalBody>
      </Modal>
    </div>
  );
};

export default CreateSeller;
